
<div class="">
    <div class="container-fluid shipment-details" style="height: 100vh;">
      <div class="row">
        <div class="col doc-header">
            Cart details
        </div>
        <div class="col-auto ml-auto doc-header">
          ID: {{cartDetails.id}}
        </div>
      </div>
      <div class="row mt-40">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Colour:
          </div>
          <div class="value">
            {{cartDetails.color}}
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            Date of creation:
          </div>
          <div class="value" *ngIf="cartDetails.dateOfCreation">
            {{cartDetails.dateOfCreation}}
          </div>
          <div class="value" *ngIf="!cartDetails.dateOfCreation">
            -
          </div>
        </div>
      </div>
      <div class="row mt-24">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Capacity:
          </div>
          <div class="value">
            {{cartDetails.capacity}}
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            Created by:
          </div>
          <div class="value">
            {{cartDetails.createdBy}}
          </div>
        </div>
      </div>
      <div class="row mt-24">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Quantity:   
          </div>
          <div class="value">
            {{cartDetails.quantity}}
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            Location:  
          </div>
          <div class="value">
            {{cartDetails.location}}
          </div>
        </div>
      </div>
      <div class="row mt-40">
        <div class="col-12">
          <table class="table inner-table">
            <thead>
              <tr>
                <th scope="col">Sample type</th>
                <th scope="col">Sample ID</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="cartDetails.details">
                <tr *ngFor="let task of cartDetails.details">
                  <td>{{task.sampleType}}</td>
                  <td>{{task.sampleId}}</td>
                  <td>{{task.status}}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="!cartDetails.details || 
              (cartDetails.details && 
              cartDetails.details.length == 0)">
                <tr>
                  <td colspan="3" style="text-align: center;">There are no sample available</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>